var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H8C8 17.4477 7.55228 17 7 17V18ZM7 23H6C6 23.3603 6.19379 23.6927 6.5073 23.8702C6.82081 24.0477 7.20556 24.0429 7.5145 23.8575L7 23ZM15.3333 18V17C15.1521 17 14.9743 17.0493 14.8188 17.1425L15.3333 18ZM2 3C2 2.44772 2.44772 2 3 2V0C1.34315 0 0 1.34315 0 3H2ZM2 16V3H0V16H2ZM3 17C2.44771 17 2 16.5523 2 16H0C0 17.6569 1.34315 19 3 19V17ZM7 17H3V19H7V17ZM8 23V18H6V23H8ZM14.8188 17.1425L6.4855 22.1425L7.5145 23.8575L15.8478 18.8575L14.8188 17.1425ZM21 17H15.3333V19H21V17ZM22 16C22 16.5523 21.5523 17 21 17V19C22.6569 19 24 17.6569 24 16H22ZM22 3V16H24V3H22ZM21 2C21.5523 2 22 2.44772 22 3H24C24 1.34315 22.6569 0 21 0V2ZM3 2H21V0H3V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7H18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8afc961ff0e1326b349da5e1dad52f7a.svg";
export { ForwardRef as ReactComponent };